module.exports = __webpack_public_path__ + "img/status-eveywhere.53990d39.png";